import BillsDiscoveryAccounts from '../../../bills/components/BillsDiscoveryAccounts';

export default function AddMoreBillsScreen() {
    return <BillsDiscoveryAccounts screenContext="addMoreBills" />;
}
